import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { CreateClientBodyNetType } from "./NetTypes";

async function createClientOrgRequest({ email, clientName }: CreateClientBodyNetType) {
	return await apiClient
		.post(API.COMMAND.ADMIN.CLIENTS, {
			email,
			clientName,
			onlyPlatform: false
		})
		.then((res) => res.data);
}

export function useCreateOrgClient() {
	return useMutation<any, AxiosError, CreateClientBodyNetType>({
		mutationFn: (payload: CreateClientBodyNetType) => createClientOrgRequest(payload)
	});
}
